import {auth} from '@/lib/firebaseAuth';

export const createJobApplication = async (jobData, resumeFile = null) => {
  try {
    const firebaseUser = auth.currentUser;
    if (!firebaseUser) {
      throw new Error('Authentication required. Please sign in with Google.');
    }

    const idToken = await firebaseUser.getIdToken();
    const processedData = prepareJobData(jobData, firebaseUser);

    const formData = buildFormData(processedData, resumeFile);

    const response = await fetch(`${import.meta.env.VITE_API_URL}/job-application`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
      },
      body: formData,
    });

    await handleApiErrors(response);

    const data = await response.json();
    console.log("Job application created successfully:", data);

    return {
      id: data.id,
      success: data.success,
    };
  } catch (error) {
    console.error('Error creating job application:', error);
    throw error;
  }
};

function prepareJobData(jobData, firebaseUser) {
  const processedData = {...jobData};
  const enumFields = ['employment_type', 'seniority_levels', 'remote_mode', 'time_recency'];

  enumFields.forEach(field => {
    if (processedData[field] === '') {
      processedData[field] = null;
    }
  });

  // ✅ גרסה קצרה, חכמה ונקייה לטיפול באימייל:
  processedData.email = processedData.email?.trim() || firebaseUser.email;

  if (!processedData.email) {
    throw new Error('Email is required but not available.');
  }

  return processedData;
}

function buildFormData(processedData, resumeFile) {
  const formData = new FormData();

  if (resumeFile) {
    formData.append('resume_file', resumeFile);
  }

  Object.entries(processedData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return formData;
}

async function handleApiErrors(response) {
  if (response.ok) return;

  const errorData = await response.json();
  console.error("API Error:", errorData);

  if (response.status === 403) {
    if (errorData.detail?.includes("Free package already used")) {
      throw new Error("You've already used your free package. Please choose a different package.");
    }
    if (errorData.detail?.includes("Email in request does not match")) {
      throw new Error("The email used for login doesn't match the email in your application. Please sign in with the correct account.");
    }
    throw new Error(errorData.detail || "Access denied. You don't have permission to submit this application.");
  }

  if (response.status === 422) {
    throw new Error("Your application contains invalid information. Please check your input and try again.");
  }

  if (response.status === 401) {
    throw new Error("Your session has expired. Please sign in again to continue.");
  }

  throw new Error(errorData.detail || 'Failed to create job application. Please try again later.');
}

export const JobApplication = {
  create: createJobApplication,
};